import React, { useMemo, useContext, useState, useEffect } from "react";
import { ConfigProvider, theme } from "antd";
import useUpdate from "hooks/useUpdate";
import dayjs from "dayjs";

import "dayjs/locale/pl";
import plPL from "antd/locale/pl_PL";

dayjs.locale("pl");

const SettingsContext = React.createContext();

const { defaultAlgorithm, darkAlgorithm } = theme;

function SettingsProvider({ children }) {
  const [mode, setMode] = useState("light");

  const { update } = useUpdate({
    path: `/users/set_theme`,
    show_notification: false,
  });

  const handleSetMode = (new_mode, save = false) => {
    if (save) {
      update({ theme: new_mode });
    }
    setMode(new_mode);
  };

  useEffect(() => {
    document.querySelector("body").classList = `${mode}-mode`;
  }, [mode]);

  const value = useMemo(() => {
    return { mode, handleSetMode };
    // eslint-disable-next-line
  }, [mode]);

  return (
    <SettingsContext.Provider value={value}>
      <ConfigProvider
        locale={plPL}
        theme={{
          token: {
            colorPrimary: "#f6a400",
            colorText: mode === "dark" ? "#ffffff" : "#000000",
          },
          algorithm: mode === "dark" ? darkAlgorithm : defaultAlgorithm,
        }}
      >
        {children}
      </ConfigProvider>
    </SettingsContext.Provider>
  );
}

const useSettings = () => useContext(SettingsContext);
export { useSettings };
export default SettingsProvider;
